import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Flame, AlertTriangle } from "lucide-react";

export default function AttendanceStreaks({ section, refreshKey }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/attendance/stats", { params: { section } }).then((r) => setStats(r.data)).catch(() => setStats(null));
  }, [section, refreshKey]);

  if (!stats || stats.meetings_total === 0) return null;

  return (
    <Card className="card-shadow-soft" data-testid="attendance-streaks">
      <CardContent className="p-5">
        <h2 className="font-bold text-lg mb-1" style={{ fontFamily: "Outfit" }}>Streaks & missed weeks</h2>
        <p className="text-xs text-muted-foreground mb-3">Across {stats.meetings_total} recorded meeting{stats.meetings_total === 1 ? "" : "s"}</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
          {stats.members.map((m) => (
            <div key={m.member_id} data-testid={`streak-row-${m.member_id}`} className="flex items-center justify-between gap-3 py-2 border-b border-border text-sm">
              <div className="min-w-0">
                <div className="font-medium truncate">{m.full_name}</div>
                <div className="text-xs text-muted-foreground">{m.attended}/{m.meetings} · {m.rate}%</div>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span data-testid={`streak-${m.member_id}`} className={`scout-tag flex items-center gap-1 ${m.streak > 0 ? "bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300" : "bg-secondary text-muted-foreground"}`}>
                  <Flame className="w-3 h-3" /> {m.streak} streak
                </span>
                <span data-testid={`missed-${m.member_id}`} className={`scout-tag flex items-center gap-1 ${m.missed > 0 ? "bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300" : "bg-secondary text-muted-foreground"}`}>
                  <AlertTriangle className="w-3 h-3" /> {m.missed} missed
                </span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
